<template>
  <div class="col">
      <div class="row align-items-start mt-3 itinerary">
        <div class="col-auto itinerary__outbound">
          <div class="row flex-column">
            <div class="col-auto">
              <div class="row">
                <div class="col-auto day-containerOut">
                    <div class="row flex-colum --dateOut">
                      <span class="day-of-week">{{dates.departure.dayOfWeek}}</span>
                    </div>
                    <div class="row flex-colum --dateOut">
                      <span>{{dates.departure.date}}</span>
                    </div>
                </div>
                <div class="col-auto code-container">
                  <span class="code">{{ search.origin }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-auto itinerary__icon" :class="isRoundTrip ? 'mt-1' : 'mt-2'">
          <div class="row flex-column" :class="{'round-trip': isRoundTrip}">
            <div class="col-auto">
              <i class="fas fa-plane"></i>
            </div>
            <div v-if="isRoundTrip"  class="col-auto">
              <i class="fas fa-plane" style="transform: scaleX(-1);"></i>
            </div>
          </div>
        </div>

        <div class="col-auto itinerary__return">
          <div class="row flex-column">
            <div class="col-auto">
              <div class="row ">
                <div class="col-auto code-container">
                  <span class="code">{{ search.destination }}</span>
                </div>
                <div  v-if="isRoundTrip"  class="col-auto day-containerRet">
                    <div class="row flex-colum --dateRet">
                      <span class="day-of-week">{{dates.return.dayOfWeek}}</span>
                    </div>
                    <div class="row flex-colum --dateRet">
                      <span>{{dates.return.date}}</span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CtwInfoSearchCExpanded',
  components: {
  },
  props: {
    search: {
      type: Object,
      required: true
    },
    dates: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showSearcher: false
    }
  },
  methods: {
  },
  computed: {
    isRoundTrip () {
      return this.search.return_flight
    },
    lang () {
      return this.$store.getters.getLanguage
    }
  }
}
</script>

<style lang="sass" scoped>
$color-primary: var(--color-primary)
$color-secondary: var(--color-secondary)
$color-surface: var(--color-onSurface)
$font-size-xl: var(--font-size-xl)
$font-size-lg: var(--font-size-lg)
$font-size-md: var(--font-size-md)
$font-size-sm: var(--font-size-sm)
$font-size-base: var(--font-size-base)
$font-size-sbase: var(--font-size-sbase)

.itinerary
    font-size: $font-size-md
    justify-content: center

    &__icon
      font-size: 18px
      color: $color-secondary
      padding: 0px 16px
      .round-trip
        font-size: $font-size-sbase

    &__outbound,
    &__return
      color: $color-primary

      i
        color: $color-secondary

      .--dateOut
        font-size: $font-size-sm
        color: $color-surface
        justify-content: right
        i
          color: $color-surface
        .day-of-week
            border-radius: var(--b-radius-sm)
            font-weight: 700

      .--dateRet
        font-size: $font-size-sm
        color: $color-surface
        justify-content: left
        i
          color: $color-surface
        .day-of-week
            border-radius: var(--b-radius-sm)
            font-weight: 700
      .day-containerOut
        display: grid
        align-items: center
        margin-right: 8px
      .day-containerRet
        display: grid
        align-items: center
        margin-left: 8px
      .code-container
        display: flex
        font-size: $font-size-lg
        padding: 2px 4px
        align-items: center
        border-radius: var(--b-radius-sm)
        background: var(--color-overlay-05)

        .code
          padding: 2px
.airportContainer
  display: flex
  flex-direction: row
  align-items: center
</style>
